import React from 'react';

import FormItem, { formatStr } from './form-item';
import MandatoryFormItem from './form-mandatory-item';

const AffiliateSettings = ({
  defaultAffiliate,
  linkmateAffiliate,
  amazonConfig,
  setAmazonConfig,
  impactRadiusUrl,
  setImpactRadiusUrl,
  linkShareMemberId,
  setLinkShareMemberId,
  skimLinkId,
  setSkimLinkId,
  pmgUrl,
  setPmgUrl,
  vigilinkKey,
  setVigilinkKey,
  fieldErrors,
  notes,
  setNotes,
  affiliateTypes,
  setDefaultAffiliate,
  setLinkmateAffiliate,
}) => {
  const affiliateMap = {
    Amazon: { value: amazonConfig, setter: setAmazonConfig, label: 'Amazon Tracking ID' },
    ImpactRadius: {
      value: impactRadiusUrl,
      setter: setImpactRadiusUrl,
      label: 'Impact Radius Url',
    },
    Linkshare: {
      value: linkShareMemberId,
      setter: setLinkShareMemberId,
      label: 'Linkshare Member ID',
    },
    Skimlinks: { value: skimLinkId, setter: setSkimLinkId, label: 'Skimlinks ID' },
    PMG: { value: pmgUrl, setter: setPmgUrl, label: 'PMG Tracking Url' },
    Viglink: { value: vigilinkKey, setter: setVigilinkKey, label: 'Viglink Key' },
  };

  const defaultAffiliateItem = affiliateMap[defaultAffiliate.value];
  const linkmateAffilateItem = affiliateMap[linkmateAffiliate.value];

  const defaultAffiliateFormItem = defaultAffiliateItem ? (
    <MandatoryFormItem
      value={defaultAffiliateItem.value}
      setter={defaultAffiliateItem.setter}
      label={defaultAffiliateItem.label}
      type={formatStr(defaultAffiliate.label)}
      fieldErrors={fieldErrors}
    />
  ) : null;

  const linkmateAffiliateFormItem = linkmateAffilateItem ? (
    <MandatoryFormItem
      value={linkmateAffilateItem.value}
      setter={linkmateAffilateItem.setter}
      label={linkmateAffilateItem.label}
      type={formatStr(linkmateAffiliate.label)}
      fieldErrors={fieldErrors}
    />
  ) : null;

  const affiliateFormItems =
    defaultAffiliate.value === linkmateAffiliate.value ? (
      <div className="affiliate-items">{defaultAffiliateFormItem}</div>
    ) : (
      <div className="affiliate-items">
        {defaultAffiliateFormItem}
        {linkmateAffiliateFormItem}
      </div>
    );

  return (
    <div className="affilate-settings">
      <div className="form-item">
        <label className="feed-config-header">Affiliate Settings</label>
      </div>
      <FormItem
        label="Default Affiliate"
        value={defaultAffiliate}
        setter={setDefaultAffiliate}
        items={affiliateTypes}
      />
      <FormItem
        label="Linkmate Affiliate"
        value={linkmateAffiliate}
        setter={setLinkmateAffiliate}
        items={affiliateTypes}
      />
      {affiliateFormItems}
      <div className="form-item notes">
        <label>Notes</label>
        <textarea
          type="textarea"
          className="notes"
          value={notes}
          onChange={e => setNotes(e.target.value)}
        />
      </div>
    </div>
  );
};

export default AffiliateSettings;
